module.exports = __webpack_public_path__ + "static/media/takePhoto.eab5119f.svg";